import { usePlaybackStateStore } from '../../store';
export const getRequestedContent = (content) => {
    const { content: current, isPlaying } = usePlaybackStateStore.getState();
    const isInContext = content?.id === current?.id;
    let requestedContent = content || current;
    return {
        content: requestedContent,
        isInContext,
        isPlaying,
        type: requestedContent?.asset?.type,
    };
};
//# sourceMappingURL=getRequestedContent.js.map